
<template>
    <div class="qksm qksm14">
        <h4>十四、预算绩效评价工作开展情况</h4>
        <div class="nogap">
            <p v-if="$store.state.divData.zone == 'gulou' && !isAdmin">
                2020年度，本部门共{{isInteger(qksm['重点绩效项目'])}}个项目开展了财政重点绩效评价，
                涉及财政性资金合计{{isMoney(qksm['开展财政性资金'])}}万元；
                本部门开展财政整体支出重点绩效评价，涉及财政性资金{{isMoney(qksm['整体财政性资金'])}}万元；
                本部门单位共{{isInteger(qksm['绩效自评'])}}个项目开展了绩效自评，
                涉及财政性资金合计{{isMoney(qksm['涉及财政性资金'])}}万元。
            </p>
            <p v-else>
                2020年度，本部门共<reason type="integer" classname="qksm integer" name="重点绩效项目" v-model:value="qksm['重点绩效项目']"></reason>
                个项目开展了财政重点绩效评价，涉及财政性资金合计
                <reason type="money" classname="qksm money " name="开展财政性资金" v-model:value="qksm['开展财政性资金']"></reason>万元；
                本部门
                <reason type="select" classname="qksm select " name="是否开展" v-model:value="qksm['是否开展']"></reason>
                财政整体支出重点绩效评价，涉及财政性资金
                <reason type="money" classname="qksm money " name="整体财政性资金" v-model:value="qksm['整体财政性资金']" v-if="qksm['是否开展']=='开展'"></reason>
                <template v-else>
                    0
                </template>万元；
                本部门单位共<reason type="integer" classname="qksm integer" name="绩效自评" v-model:value="qksm['绩效自评']"></reason>个项目开展了绩效自评，
                涉及财政性资金合计<reason type="money" classname="qksm money " name="涉及财政性资金" v-model:value="qksm['涉及财政性资金']"></reason>万元。
            </p>
        </div>
    </div>
</template>
<script>
    //鼓楼默认开展，整体财政性资金取表一本年支出，单位用户没有修改他们权限
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm14",
        components: {
            reason,
        },
        props: {
            T1: {
                type: Object,
                default: "",
            },
        },
        data() {
            var scope = this.$store.state.userDetail.scope
            var isAdmin = scope.length == 1 && ((scope[0].type == 0 && !scope[0].value) || (scope[0].type == 0 && scope[0].value == this.$cookies.get("zone"))) ? true :false
            var qksm = this.$store.state.divData.qksm
            if (this.$store.state.divData.zone == "gulou") {
                if (this.$store.state.divData.divname != '徐州市鼓楼区农机管理服务站') {
                    qksm['是否开展'] = '开展'
                }
                qksm['整体财政性资金'] = this.pickOneOf(qksm['整体财政性资金'], this.T1["支出"]["本年支出"])
            }
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm,
                isAdmin: isAdmin
            }
        },
        created() {
            this.inspect()
        },
        updated: function () {
            this.inspect()
        },
        methods: {
            inspect() {
                if (this.qksm['是否开展'] == "开展" && this.num(this.qksm['整体财政性资金']) == 0){
                   this.addOrSet("qksm14", "请检查本页《十四、预算绩效评价工作开展情况》，如本部门财政整体支出重点绩效评价选择“开展”，涉及财政性资金必须要大于“0”万元。");
                } else {
                    this.remove("qksm14")
                }
                if (this.num(this.qksm['重点绩效项目']) > 0 && this.num(this.qksm['开展财政性资金']) <= 0) {
                    this.addOrSet("qksm141", "请检查本页《十四、预算绩效评价工作开展情况》，如开展财政重点绩效评价的项目个数大于0，则涉及财政性资金合计数必须大于0。");
                } else if (this.num(this.qksm['重点绩效项目']) == 0 && this.num(this.qksm['开展财政性资金']) != 0) {
                    this.addOrSet("qksm141", "请检查本页《十四、预算绩效评价工作开展情况》，如开展财政重点绩效评价的项目个数为0，则涉及财政性资金合计数必须等于0。");
                } else {
                    this.remove("qksm141")
                }
                if (this.num(this.qksm['绩效自评']) > 0 && this.num(this.qksm['涉及财政性资金']) <= 0) {
                    this.addOrSet("qksm142", "请检查本页《十四、预算绩效评价工作开展情况》，如开展绩效自评的项目个数大于0，则涉及财政性资金合计数必须大于0。");
                } else if (this.num(this.qksm['绩效自评']) == 0 && this.num(this.qksm['涉及财政性资金']) != 0) {
                    this.addOrSet("qksm142", "请检查本页《十四、预算绩效评价工作开展情况》，如开展绩效自评的项目个数为0，则涉及财政性资金合计数必须等于0。");
                } else {
                    this.remove("qksm142")
                }

            }
        }
    };
</script>
